import { useAnswerer } from "./useAnswerer";

export const useRequireAgreedAnswerer = (id: string) => {
    const { answerer, isLoading, clearCache } = useAnswerer(id);

    const isAgreed = !!answerer && !!answerer.isPrivacyAndUsageTermsAgreed;

    return {
        answerer,
        isLoading,
        isAgreed,
        clearCache,
    };
};
